import React from "react";
import { Button, Tooltip } from "@mui/material";
import PieChartIcon from "@mui/icons-material/PieChart";
import BarChartIcon from "@mui/icons-material/BarChart";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";

const ButtonStyle = {
  padding: "8px 6px",
  minHeight: "72px",
  fontSize: "10px",
  lineHeight: 1.4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

const IconStyle = {
  fontSize: "15px",
  border: "1px solid white",
  marginTop: "8px",
};

const IconMapping = {
  PieChartIcon: PieChartIcon,
  BarChartIcon: BarChartIcon,
  ShowChartIcon: ShowChartIcon,
  StackedLineChartIcon: StackedLineChartIcon,
};

export const ReportsButton = ({
  handleButtonClick,
  buttonType,
  title,
  icon = null,
  comingSoon = false,
}) => {
  const getIcon = () => {
    if (icon && IconMapping.hasOwnProperty(icon)) {
      const IconComponent = IconMapping[icon];
      return <IconComponent style={IconStyle} />;
    }
    return null;
  };

  const button = (
    <Button
      style={ButtonStyle}
      variant={"contained"}
      color={"primary"}
      disabled={comingSoon}
      onClick={() => handleButtonClick(buttonType)}
      sx={{ width: "100%" }}
    >
      {title}
      {getIcon()}
    </Button>
  );
  // a disabled button takes no pointer events, so the tooltip sits on a wrapper
  return comingSoon ? (
    <Tooltip title="Coming soon">
      <span style={{ display: "flex" }}>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};
